export class BusinessError extends Error {
  constructor(
    public readonly code: number,
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options)
    this.name = 'BusinessError'
  }
}

export class AuthExpiredError extends BusinessError {
  constructor(code: number, message: string, options?: ErrorOptions) {
    super(code, message, options)
    this.name = 'AuthExpiredError'
  }
}

export class HttpError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options)
    this.name = 'HttpError'
  }
}
